import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';

export const hiddenStatuses = ['purged', 'created'] as const;
export const disallowedStatuses = [...hiddenStatuses, 'split'] as const;

export const DISALLOWED_STATUSES_FILTER_ITEM: GridFilterItem = {
  field: 'status',
  operator: 'notIn',
  value: disallowedStatuses,
};
